/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FacultyCoordinatorDTO
 */
export interface FacultyCoordinatorDTO {
	/**
	 *
	 * @type {string}
	 * @memberof FacultyCoordinatorDTO
	 */
	facultyCoordinatorId?: string | null;
}

export function FacultyCoordinatorDTOFromJSON(
	json: any
): FacultyCoordinatorDTO {
	return FacultyCoordinatorDTOFromJSONTyped(json, false);
}

export function FacultyCoordinatorDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): FacultyCoordinatorDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		facultyCoordinatorId: !exists(json, "facultyCoordinatorId")
			? undefined
			: json["facultyCoordinatorId"],
	};
}

export function FacultyCoordinatorDTOToJSON(
	value?: FacultyCoordinatorDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		facultyCoordinatorId: value.facultyCoordinatorId,
	};
}
